import actions from './moduleFileActions.js'

export default {
  namespaced: true,
  actions
}
